export default __webpack_public_path__ + "static/media/026-puss in boots.f24572ec.svg";